import _ from 'underscore';
import $ from 'jquery';

export default class ProductGroupSpecRanges {
  constructor($scope, ProductService) {
    $scope.tabs = [
      {
        title: 'Groups with Ranges',
        groups: []
      },
      {
        title: 'Groups without Ranges',
        groups: []
      }
    ];

    $scope.dialog_tabs = [
      {
        title: 'Reels',
        ranges: []
      },
      {
        title: 'Sheets',
        ranges: []
      }
    ];

    $scope.set_selected_tab = function(index) {
      $scope.selected_tab = index;
    };

    $scope.set_selected_dialog_tab = function(index) {
      $scope.selected_dialog_tab = index;
    };

    $scope.load_groups = function() {
      $scope.loading = true;
      ProductService.get_groups_with_ranges().success(function(data) {
        _.each(data.groups, function(group) {
          var index = group.reel_ranges.length > 0 || group.sheet_ranges.length > 0 ? 0 : 1;
          $scope.tabs[index].groups.push(group);
        });
        $scope.loading = false;
      });
    };

    $scope.show_ranges = function(group) {
      $scope.dialog_group = group;
      $scope.dialog_tabs[0].ranges = group.reel_ranges;
      $scope.dialog_tabs[1].ranges = group.sheet_ranges;
      $.fancybox($('div#ranges'), {
        padding: '5',
        openEffect: 'elastic',
        closeEffect: 'elastic',
        openSpeed: '700',
        closeSpeed: '300',
        topRatio: 0.15,
        scrolling: 'no'
      });
    };

    $scope.add_reel_range = function() {
      $scope.dialog_group.reel_ranges.push($scope.get_reel_range());
    };

    $scope.get_reel_range = function() {
      return {
        id: null,
        substance_min: 0,
        substance_max: 0,
        rw_min: 0,
        rw_max: 0
      };
    };

    $scope.delete_reel_range = function(range) {
      $scope.dialog_group.reel_ranges.splice(_.indexOf($scope.dialog_group.reel_ranges, range), 1);
    };

    $scope.add_sheet_range = function() {
      $scope.dialog_group.sheet_ranges.push($scope.get_sheet_range());
    };

    $scope.get_sheet_range = function() {
      return {
        id: null,
        substance_min: 0,
        substance_max: 0
      };
    };

    $scope.delete_sheet_range = function(range) {
      $scope.dialog_group.sheet_ranges.splice(_.indexOf($scope.dialog_group.sheet_ranges, range), 1);
    };

    $scope.save_ranges = function() {
      $scope.saving_ranges = true;
      ProductService.update_group_ranges($scope.dialog_group).success(function(data) {
        if (data.success) {
          $scope.dialog_group.reel_ranges = data.reel_ranges;
          $scope.dialog_group.sheet_ranges = data.sheet_ranges;
          _.each($scope.tabs, function(tab) {
            var group = _.findWhere(tab.groups, {
              id: data.id
            });
            if (group)
              tab.groups.splice(_.indexOf(tab.groups, group), 1);
          });
          if (data.reel_ranges.length === 0 && data.sheet_ranges.length === 0) {
            $scope.tabs[1].groups.push($scope.dialog_group);
          } else {
            $scope.tabs[0].groups.push($scope.dialog_group);
          }
          $scope.saving_ranges = false;
          $.fancybox.close();
        }
      });
    };

    $scope.update_supplier_pricings = function(product_group) {
      product_group.updating_supplier_pricings = true;
      ProductService.update_range_supplier_pricings(product_group.id).success(function(data) {
        if (data.success)
          product_group.updating_supplier_pricings = false;
      });
    };

    $scope.update_buyer_pricings = function(product_group) {
      product_group.updating_buyer_pricings = true;
      ProductService.update_range_buyer_pricings(product_group.id).success(function(data) {
        if (data.success)
          product_group.updating_buyer_pricings = false;
      });
    };

    $scope.init = function() {
      $scope.selected_tab = 0;
      $scope.selected_dialog_tab = 0;
      $scope.load_groups();
    };

    $scope.init();
  }
}

ProductGroupSpecRanges.$inject = ['$scope', 'ProductService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/product-group-spec-ranges.ctrl.js